import { makeStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
    wrapper: {
        maxWidth: '100px',
        width: '100%',
        aspectRatio: '3 / 1',
        overflow: 'hidden',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    loadingAnimation: {
        width: '180%',
        height: 'auto',
        objectFit: 'contain',
        flexShrink: 0,
    },

});

export default styles;

export const useStyles = makeStyles(styles);
